import ComingSoon from '../../Components/Errors/Comingsoon';
import Footer from '../../Components/Footer';
import Navbar from '../../Components/Navbar';
import Post from '../../Components/Posts pages/PostStory';
import Landingpage from '../Home/Landingpage';



export default function Postoage() {

    return(<>
    <Navbar />
    <Landingpage />
    <Post />
    <Footer />
    </>);
}